<template>
	<div>
		<b-toast id="toast-post" variant="info" class="rounded" no-auto-hide solid>
			<template #toast-title>
				<div class="d-flex flex-grow-1 align-items-baseline">
					📢✨
					<strong class="mr-auto"> Temos boas Noticias! 😁🤩</strong>
				</div>
			</template>
			<h5 class="mb-3">O sistema acabou de receber uma nova atualização.</h5>
			<button class="btn btn-success" @click="openModal">
				<span class="d-flex align-items-center">
					<i class="mdi mdi-star mdi-18px mr-2"></i>
					Confira as novidades clicando aqui
				</span>
			</button>
		</b-toast>

		<b-modal
			:hide-footer="true"
			centered
			size="xl"
			id="post-modal"
			:title="comunicado.title"
		>
			<load v-if="loading" mode="table" />
			<div v-else class="row">
				<div
					class="col-12 my-4"
					style="overflow: auto; display: block; max-height: 600px"
					v-html="comunicado.text"
				></div>
				<div class="col-12 d-flex justify-content-end">
					<button class="btn btn-success" @click="markRead">
						<i class="mdi mdi-check-circle"></i> Marcar como lida
					</button>
				</div>
			</div>
		</b-modal>
	</div>
</template>

<script>
import { FlowerSpinner } from "epic-spinners";
// import Echo from "laravel-echo";
import socket from "@/dashboard/socket";
export default {
	components: {
		//Echo,
		FlowerSpinner,
	},
	data() {
		return {
			loading: false,
			comunicado: { title: "", text: "" },
			notification_id: "",
			urlApp: `${window.location.protocol}//${window.location.host}`,
			urlsound: `${window.location.protocol}//${window.location.host}/sound/chat.mp3`,
		};
	},
	//created() {
	// Pusher.logToConsole = true;
	// var pusher = new Pusher(this.$store.state.settings.pusher_key, {
	//     cluster: this.$store.state.settings.pusher_app_cluster,
	// });
	// var channel = pusher.subscribe("post");
	// channel.bind("post-event", (data) => {
	//     this.makeToast(data);
	// });
	// },
	created() {
		// let userID = this.$store.state.user.id;
		// let username = this.$store.state.user.name;
		// // let path = this.urlApp;
		// // let path = this.$store.state.settings.path;
		// socket.auth = { userID, username };
		// socket.userID = userID;
		// socket.connect();
		// socket.emit("set user logado", this.$store.state.user, this.urlApp);
		// //console.log("teste d");
		socket.on("post.event", (id) => {
			//console.log("evento recebido");
			this.makeToast(id);
		});
	},
	mounted() {
		// let userID = this.$store.state.user.id;
		// let username = this.$store.state.user.name;
		// // let path = this.urlApp;
		// // let path = this.$store.state.settings.path;
		// socket.auth = { userID, username };
		// socket.userID = userID;
		// socket.connect();

		// this.$bvToast.show("toast-post");
		socket.on("post.event", (id) => {
			//console.log("evento recebido mounted");
			this.makeToast(id);
		});
	},
	methods: {
		makeToast(id) {
			this.notification_id = id;
			this.$bvToast.show("toast-post");
			this.beep();
		},
		openModal() {
			this.$bvToast.hide("toast-post");
			this.$bvModal.show("post-modal");
			this.loading = true;
			axios
				.get(`api/dashboard/post/get/${this.notification_id}`)
				.then((response) => {
					this.comunicado = response.data;
				})
				.finally(() => {
					this.loading = false;
				});
		},
		markRead() {
			this.loading = true;
			axios
				.get(`api/dashboard/post/read/${this.notification.id}`)
				.then((response) => {
					this.$bvModal.hide("post-modal");
				})
				.finally(() => {
					this.loading = false;
				});
		},
		beep() {
			var audio = document.getElementById("audio");
			let startPlayPromise = audio.play();

			if (startPlayPromise !== undefined) {
				startPlayPromise
					.then(() => {
						// Start whatever you need to do only after playback
						// has begun.
					})
					.catch((error) => {
						if (error.name === "NotAllowedError") {
							// showPlayButton(audio);
						} else {
							// Handle a load or playback error
						}
					});
			}
		},
	},
};
</script>

<style lang="css" scoped>
.list-group-item {
	position: relative;
	display: block;
	padding: 0.75rem 1.25rem;
	background-color: #fff;
	border: 0 !important;
	border-bottom: 1px solid #f4f4f4 !important;
	cursor: pointer;
	font-weight: bold;
	font-size: 14px;
	text-transform: uppercase;
}
.list-group-item:hover {
	background: #f4f4f4;
}

::-webkit-scrollbar-track {
	background-color: #f4f4f4;
}
::-webkit-scrollbar {
	width: 5px;
	background: #f4f4f4;
}
::-webkit-scrollbar-thumb {
	background: #979797;
	border-radius: 25em;
}

.morris-hover {
	position: absolute;
	z-index: 99 !important;
}
.new-btn-chat {
	display: flex;
	width: 45px;
	height: 45px;
	justify-content: center;
	align-items: center;
	flex-direction: column;
	border: 0;
	background: #1f89e5;
	color: #fff;
	border-radius: 50%;
	transition: all 0.2s;
	-webkit-transform: scale(1);
	-moz-transform: scale(1);
	-o-transform: scale(1);
	transform: scale(1);
	border: 2px solid #fff;
}

.new-btn-chat:hover {
	background: #44a8ff;
	box-shadow: 0 20px 30px rgba(0, 0, 0, 0.3);
	-webkit-transform: scale(1.4);
	-moz-transform: scale(1.4);
	-o-transform: scale(1.4);
	transform: scale(1.4);
}

.btn-animated {
	animation: moveInBottom 5s ease-out;
	animation-fill-mode: backwards;
}
@keyframes moveInBottom {
	0% {
		opacity: 0;
		transform: scale(1.4);
	}

	100% {
		opacity: 1;
		transform: scale(0px);
	}
}

/* .btn-chat {
  font-size: 18px;
  color: #fff;
  background: #1f89e5;
  padding: 7.5px 10px 7.5px 10px;
  border-radius: 50%;
  box-shadow: 0 1px 4px 0px rgb(0 0 0 / 39%);
  cursor: pointer;
  z-index: 9999;
  min-height: 40px;
  max-height: 40px;
  height: 40px;
  overflow: hidden;
} */
/* .btn-chat:hover {
  background: #0d5a9e;
} */
.chat-app {
	display: flex;
}
.box-chat {
	position: fixed;
	z-index: 1001;
	bottom: 30px;
	right: 30px !important;
	display: block;
	width: 50%;
	height: calc(100% - 200px);
	overflow: hidden;
	border-radius: 2px;
	background: white;
	box-shadow: 0 0.5rem 1rem rgb(0 0 0 / 15%) !important;
	max-width: 800px;
	padding: 1rem;
	overflow: auto;
}

@media (min-width: 767px) AND (max-width: 1200px) {
	.box-chat {
		position: fixed;
		z-index: 1001;
		bottom: 30px;
		right: 30px !important;
		display: block;
		width: 70% !important;
		height: 70vh;
		overflow: hidden;
		border-radius: 2px;
		background: white;
		box-shadow: 0 0.5rem 1rem rgb(0 0 0 / 15%) !important;
		max-width: 800px;
		overflow: auto;
	}
}
@media (min-width: 567px) AND (max-width: 767px) {
	.box-chat {
		position: fixed;
		z-index: 9999;
		bottom: 60px;
		display: none;
		width: 90%;
	}
	.direct-chat-info {
		display: block;
		margin-bottom: 2px;
		font-size: 14px;
		width: 400px;
	}
}
@media (max-width: 567px) {
	.box-chat {
		position: fixed;
		z-index: 9999;
		bottom: 60px;
		display: none;
		width: 99%;
	}
	.direct-chat-info {
		display: block;
		margin-bottom: 2px;
		font-size: 14px;
		width: 300px;
	}
}
</style>
